import { z } from 'zod/v4'
import { LiquidRenderCommandSchema } from './commands/liquid.render.schema'

// Tools service schema (schema-only import — do not pull liquid.render runtime/Prisma)
export const ToolsServiceSchema = LiquidRenderCommandSchema

// Tools service types
export type ToolsService = z.infer<typeof ToolsServiceSchema>
